import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import type { RundownSummary } from '@news-assist/shared';

interface UseRundownsOptions {
  status?: string;
  date?: string;
  limit?: number;
}

interface RundownsResponse {
  rundowns: RundownSummary[];
  hasMore: boolean;
}

export function useRundowns(options: UseRundownsOptions = {}) {
  return useQuery({
    queryKey: ['rundowns', options],
    queryFn: () =>
      apiClient.get<RundownsResponse>('/rundowns', {
        status: options.status,
        date: options.date,
        limit: options.limit,
      }),
  });
}
